module.exports = __webpack_public_path__ + "static/media/logo.acf1444e.png";